import React from 'react';

import isValid from 'date-fns/isValid';
import { graphql, useFragment } from 'react-relay';

import { StatusTargetDateDisplay } from '../../../../../../../common/ui/status-target-date-display';
import { TargetDate } from '../../../../../../../common/ui/target-date-display';
import {
	formatSpfAskStatus,
	getAskStatusAppearance,
} from '../../../../../../../common/utils/spf-ask-status';

import type { searchPassionfruitAskStatusTargetDate_AtlassianSearchPage$key } from './__generated__/searchPassionfruitAskStatusTargetDate_AtlassianSearchPage.graphql';

interface SearchPassionfruitAskStatusTargetDateProps {
	node: searchPassionfruitAskStatusTargetDate_AtlassianSearchPage$key;
}

export const SearchPassionfruitAskStatusTargetDate: ({
	node,
}: SearchPassionfruitAskStatusTargetDateProps) => React.JSX.Element | null = ({
	node,
}: SearchPassionfruitAskStatusTargetDateProps) => {
	const data = useFragment(
		graphql`
			fragment searchPassionfruitAskStatusTargetDate_AtlassianSearchPage on SearchResult {
				... on SearchResultSpfAsk {
					ask @optIn(to: "Spf") {
						status
						targetDate {
							targetDate
							targetDateType
						}
					}
				}
			}
		`,
		node,
	);

	const askStatus = formatSpfAskStatus(data.ask?.status);

	if (!askStatus) {
		return null;
	}

	const displayedStatusAppearance = getAskStatusAppearance(data.ask?.status);
	const targetDate = data.ask?.targetDate?.targetDate;
	const targetDateType = data.ask?.targetDate?.targetDateType;
	const displayedTargetDate =
		(targetDate && targetDateType && isValid(new Date(targetDate)) && (
			<TargetDate targetDate={targetDate} targetDateType={targetDateType} />
		)) ||
		undefined;

	return (
		<StatusTargetDateDisplay
			displayedStatus={askStatus}
			displayedStatusAppearance={displayedStatusAppearance}
			displayedTargetDate={displayedTargetDate}
		/>
	);
};
